export const STORAGE_PREFIX = "opt.infopub.";

export const OAUTH_STATE = "state";
export const OIDC_METADATA = "metadata";
export const TOKEN_INFO = "token_info";
export const TOKEN_EXPIRATION = "token_expiration";
export const PROFILE_INFO = "profile_info";
export const REDIRECT_TO = "redirect_to";
export const SELECTED_APP = "current_app";
export const SELECTED_PROVIDER = "current_provider";
export const EDITION = "edition";

export class Storage {
    store;
    prefix;

    constructor() {
        this.store = localStorage;
        this.prefix = STORAGE_PREFIX;
    }

    set(key, value) {
        key = this.prefix + key;
        return this.store.setItem(key, value);
    }

    get(key) {
        key = this.prefix + key;
        let item = this.store.getItem(key);
        return item !== null && undefined !== item ? item : null;
    }

    getAndRemove(key) {
        key = this.prefix + key;
        let item = this.store.getItem(key);
        this.store.removeItem(key);
        return item !== null ? item : null;
    }

    remove(key) {
        key = this.prefix + key;
        return this.store.removeItem(key);
    }

    getKeys() {
        var keys = [];

        for (let index = 0; index < this.store.length; index++) {
            let key = this.store.key(index);

            if (key !== null && key.indexOf(this.prefix) === 0) {
                keys.push(key.substr(this.prefix.length));
            }
        }

        return Promise.resolve(keys);
    }

    removeEverything() {
        this.getKeys().then((keys) => {
            for (var key in keys) {
                this.remove(key);
            }
        });
    }
}

export const storage = new Storage();